import clsx from 'clsx';
import React from 'react';
import classes from './Toast.module.scss';
import { AlertTemplateProps } from 'react-alert';
import CloseIcon from 'components/assets/alert/cross.svg';
import SuccessIcon from 'components/assets/alert/success.svg';
import InfoIcon from 'components/assets/alert/info.svg';
import Txt from 'components/atoms/Txt/Txt';

export type Props = AlertTemplateProps;

const Toast: React.FC<Props> = ({ style, options, message, close }: Props) => {
  return (
    <div style={style} className={clsx(classes.root, options.type && classes[options.type])}>
      {options.type === 'info' && <InfoIcon className={classes.infoIcon} />}
      {options.type === 'success' && <SuccessIcon className={classes.successIcon} />}
      {options.type === 'error' && <InfoIcon className={classes.errorIcon} />}
      <Txt
        component="p"
        className={clsx(classes.text, options.type && classes[`${options.type}Text`])}
        skipTranslation={options.skipTranslation}
      >
        {message}
      </Txt>
      <button type="button" onClick={close}>
        <CloseIcon className={classes.closeIcon} />
      </button>
    </div>
  );
};
export default Toast;
